import { Component, OnInit } from '@angular/core';
import { PartnerService } from 'app/00_modules/core/services/partner.service';
import { RouterService } from 'app/00_modules/core/services/router.service';
import { StorageService } from 'app/00_modules/core/services/storage.service';
import { PartnerClaim } from 'app/00_modules/core/user/Partner';
import { Observable } from 'rxjs';
import { UserFacade } from '../../../store/facade/user.facade';
import { FormsModule } from '@angular/forms';
import { JeListComponent } from '../../shared/components/inputs/list/list.component';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'je-partnerselection-container',
    standalone: true,
    templateUrl: './partner-selection.dialog.html',
    imports: [FormsModule, JeListComponent, TranslateModule, AsyncPipe],
})
export class PartnerSelectionContainerComponent implements OnInit {
    public partners$: Observable<PartnerClaim[]>;

    constructor(
        private partnerService: PartnerService,
        private router: RouterService,
        private storageService: StorageService,
        private userFacade: UserFacade
    ) {}

    public onSelectionChanged(selectedItem: Object) {
        const selectedPartner = selectedItem as PartnerClaim;
        if (selectedPartner === null) {
            return;
        }

        this.userFacade.setUserPartner(selectedPartner);
        this.storageService.setPartnerId(selectedPartner.id);
        this.router.gotoHome();
    }

    public ngOnInit(): void {
        this.partners$ = this.partnerService.getUserPartnerClaims();
    }
}
